document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');

  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const expanded = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!expanded));
      menu.hidden = expanded;
      document.body.classList.toggle('menu-open', !expanded);
    });
  }

  document.querySelectorAll('[data-quantity]').forEach((wrapper) => {
    const input = wrapper.querySelector('input');
    wrapper.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const delta = button.dataset.action === 'increase' ? 1 : -1;
        input.value = Math.max(1, Number(input.value || 1) + delta);
      });
    });
  });
});
